import Vue from "vue";
import Vuex from "vuex";
import pathify from "vuex-pathify";
import { make } from "vuex-pathify";

Vue.use(Vuex);

const state = {
  syncToken: null,
  analyticsOn: null,
  assetItems: {},
  resourceItems: {},
  collectionItems: {},
  newsItems: {},
  searchItems: {},
  introItem: null,
  infoItem: null
};

const mutations = make.mutations(state);

const getters = make.getters(state);

const actions = make.actions(state);

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  plugins: [pathify.plugin]
});
